import { Dayjs } from 'dayjs';

export enum SortVariant {
    NAME_ASC = 'NAME_ASC',
    NAME_DESC = 'NAME_DESC',
    GROUP_DESC = 'GROUP_DESC',
    GROUP_ASC = 'GROUP_ASC',
    SETTLEMENT_END_DESC = 'SETTLEMENT_END_DESC',
    SETTLEMENT_END_ASC = 'SETTLEMENT_END_ASC',
}

export type ChosenFilter =
    | { type: 'search'; value: string }
    | { type: 'groupIds'; value: string[] | undefined }
    | { type: 'date'; value: Dayjs | null }
    | {
          type: 'dateNextPrev';
          value: { direction: 'NEXT' | 'PREVIOUS'; unit?: 'day' | 'week' | 'month' };
      };

export type FilterKeys = 'groupIds';
